import React, { ReactNode } from 'react';
import { Button, Modal } from 'antd';

interface IProps {
  open: boolean;
  title: string;
  content: string;
  handleOk: () => void;
  handleCancel: () => void;
  loading?: boolean;
  showInfo?: boolean;
  info?: ReactNode;
}

const ConfirmApprove = ({
  open,
  content,
  handleOk,
  handleCancel,
  loading,
  showInfo,
  info,
}: IProps) => {
  return (
    <Modal
      width={400}
      open={open}
      onOk={() => handleOk}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={
        <div className="">
          <Button key="back" onClick={handleCancel}>
            ยกเลิก
          </Button>
          <Button
            key="submit"
            type="primary"
            form="unit"
            onClick={handleOk}
            className="m-2 bg-success"
            loading={loading}
          >
            ยืนยัน
          </Button>
        </div>
      }
    >
      <div className="">
        <div>{content}</div>
      </div>
      {showInfo && info}
    </Modal>
  );
};

export default ConfirmApprove;
